"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = reducer;
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const initialState = {
    searchInputState: {
        searchBoxState: {
            searchValue: "",
            searchBoxDisbaled: false
        },
        listFilterState: {
            selectedLanguages: [],
            listFilterDisabled: false
        }
    },
    searchSelections: {
        selectedLanguages: [],
        searchValue: ""
    },
    canSearch: false
};
function reducer(state = initialState, action) {
    const type = action.type;
    switch (type) {
        case "translation-search/SET_SELECTED_LANGUAGES": {
            return Object.assign(Object.assign({}, state), { searchInputState: Object.assign(Object.assign({}, state.searchInputState), { listFilterState: Object.assign(Object.assign({}, state.searchInputState.listFilterState), { selectedLanguages: action.selectedLanguages }) }) });
        }
        case "translation-search/SET_SEARCH_BOX_VALUE": {
            return Object.assign(Object.assign({}, state), { searchInputState: Object.assign(Object.assign({}, state.searchInputState), { searchBoxState: Object.assign(Object.assign({}, state.searchInputState.searchBoxState), { searchValue: action.value }) }) });
        }
        case "translation-search/ON_SEARCH": {
            return Object.assign(Object.assign({}, state), { canSearch: true, searchSelections: {
                    searchValue: state.searchInputState.searchBoxState.searchValue,
                    selectedLanguages: state.searchInputState.listFilterState.selectedLanguages
                } });
        }
        default:
            (0, ts_exhaustive_check_1.exhaustiveCheck)(type);
            return state;
    }
}
//# sourceMappingURL=reducer.js.map